export default "__VITE_ASSET__DYC1BogD__"